import request from '@/utils/request'
import { handlerGetUrlParams } from '@/utils/dealUrlParams.js'

// 获取企业信息
export function getEnterpriseInfo(param) {
  const url = handlerGetUrlParams('/bus/competitorLibrary/list', param)
  return request({
    url,
    method: 'GET'
  })
}

// 获取检索的企业信息
export function searchCompanyInfo(param) {
  const url = handlerGetUrlParams('/bus/competitorLibrary/search', param)
  return request({
    url,
    method: 'GET'
  })
}

// 新增同步
export function asyncAddCompany(data) {
  return request({
    url: `/bus/competitorLibrary`,
    method: 'POST',
    data
  })
}

// 删除企业信息
export function deleteEnterpriseInfo(ids) {
  return request({
    url: `/bus/competitorLibrary/${ids}`,
    method: 'DELETE'
  })
}
// 排序企业
export function competitorLibrarySort(data) {
  return request({
    url: `/bus/competitorLibrary/sort`,
    method: 'POST',
    data
  })
}
